export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  permission?: string // Permiso requerido para mostrar este item
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
      // permission: 'access.dashboard',
    },
    {
      name: 'employees',
      displayName: 'menu.employees',
      meta: {
        icon: 'badge',
      },
      permission: 'access.employees',
    },
    {
      name: 'suppliers',
      displayName: 'menu.suppliers',
      meta: {
        icon: 'store',
      },
      permission: 'access.suppliers',
    },
    {
      name: 'customers',
      displayName: 'menu.customers',
      meta: {
        icon: 'people',
      },
      permission: 'access.customers',
    },
    {
      name: 'units',
      displayName: 'menu.units',
      meta: {
        icon: 'straighten',
      },
      permission: 'access.units',
    },
    {
      name: 'taxes',
      displayName: 'menu.taxes',
      meta: {
        icon: 'request_quote',
      },
      permission: 'access.taxes',
    },
    {
      name: 'categories',
      displayName: 'menu.categories',
      meta: {
        icon: 'category',
      },
      permission: 'access.categories',
    },
    {
      name: 'products',
      displayName: 'menu.products',
      meta: {
        icon: 'mso-inventory_2',
      },
      permission: 'access.products',
    },
    {
      name: 'services',
      displayName: 'menu.services',
      meta: {
        icon: 'handyman',
      },
      permission: 'access.services',
    },
    {
      name: 'inventory-movements',
      displayName: 'menu.inventoryMovements',
      meta: {
        icon: 'mso-inventory',
      },
      permission: 'access.inventory_movements',
    },
    {
      name: 'purchases',
      displayName: 'menu.purchases',
      meta: {
        icon: 'mso-local_shipping',
      },
      permission: 'access.purchases',
    },
    {
      name: 'sales',
      displayName: 'menu.sales',
      meta: {
        icon: 'shopping_cart',
      },
      permission: 'access.sales',
    },
    {
      name: 'roles',
      displayName: 'menu.roles',
      meta: {
        icon: 'mso-admin_panel_settings',
      },
      permission: 'access.roles',
    },
    {
      name: 'permissions',
      displayName: 'menu.permissions',
      meta: {
        icon: 'verified_user',
      },
      permission: 'access.permissions',
    },
    {
      name: 'projects',
      displayName: 'menu.projects',
      meta: {
        icon: 'folder_shared',
      },
      permission: 'access.projects',
    },
    {
      name: 'payments',
      displayName: 'menu.payments',
      meta: {
        icon: 'credit_card',
      },
      permission: 'access.payments',
      children: [
        {
          name: 'payment-methods',
          displayName: 'menu.payment-methods',
          permission: 'access.payment_methods',
        },
        {
          name: 'pricing-plans',
          displayName: 'menu.pricing-plans',
          permission: 'access.pricing_plans',
        },
        {
          name: 'billing',
          displayName: 'menu.billing',
          permission: 'access.billing',
        },
      ],
    },
    {
      name: 'auth',
      displayName: 'menu.auth',
      meta: {
        icon: 'login',
      },
      permission: 'access.auth',
      children: [
        {
          name: 'login',
          displayName: 'menu.login',
          permission: 'access.auth',
        },
        {
          name: 'signup',
          displayName: 'menu.signup',
          permission: 'access.auth',
        },
        {
          name: 'recover-password',
          displayName: 'menu.recover-password',
          permission: 'access.auth',
        },
      ],
    },

    // Módulo Óptico - Appointments
    {
      name: 'appointments',
      displayName: 'menu.appointments',
      meta: {
        icon: 'mso-calendar_month',
      },
      permission: 'access.appointments',
    },

    // Módulo Óptico - Optical Exams
    {
      name: 'exams',
      displayName: 'menu.opticalExams',
      meta: {
        icon: 'mso-assignment',
      },
      permission: 'access.optical_exams',
    },

    // Módulo Óptico - Pathologies
    {
      name: 'pathologies',
      displayName: 'menu.pathologies',
      meta: {
        icon: 'mso-local_hospital',
      },
      permission: 'access.pathologies',
    },

    {
      name: 'faq',
      displayName: 'menu.faq',
      meta: {
        icon: 'quiz',
      },
      permission: 'access.faq',
    },
    {
      name: '404',
      displayName: 'menu.404',
      meta: {
        icon: 'vuestic-iconset-files',
      },
      permission: 'access.404',
    },
    {
      name: '403',
      displayName: 'menu.403',
      meta: {
        icon: 'block',
      },
      permission: 'access.403',
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'group',
      },
      permission: 'access.users',
    },
    {
      name: 'preferences',
      displayName: 'menu.preferences',
      meta: {
        icon: 'manage_accounts',
      },
      // Preferencias generalmente accesibles para todos
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'settings',
      },
      // permission: 'access.settings',
    },
  ] as INavigationRoute[],
}
